import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Navigation } from '../navigation/nav-item.model';
import { ShellAccount, ShellBranding } from '../shell.facade';

/**
 * The app frame: the sidebar (folded behind a top bar on small screens), the page projected in
 * the middle, and the banner shown while a platform admin controls an organisation.
 */
@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ShellComponent implements OnChanges {
    @Input({ required: true }) branding!: ShellBranding;
    @Input({ required: true }) navigation!: Navigation;
    @Input({ required: true }) account!: ShellAccount;
    @Input({ required: true }) currentUrl = '';
    @Input() loading = false;
    @Input() languages: string[] = [];
    @Input() currentLanguage = '';
    @Input() freeTrialDaysLeft: number | null = null;
    @Input() showPoweredBy = false;
    /** The organisation a platform admin is controlling, or null outside impersonation. */
    @Input() controlledOrganization: string | null = null;

    @Output() readonly languageChange = new EventEmitter<string>();
    @Output() readonly logout = new EventEmitter<void>();
    @Output() readonly contactSales = new EventEmitter<void>();
    @Output() readonly stopControlling = new EventEmitter<void>();

    /** Whether the sidebar is unfolded over the page on a small screen. */
    navOpen = false;

    ngOnChanges(changes: SimpleChanges): void {
        // Fold the sidebar away once another page opens.
        if (changes['currentUrl'] && !changes['currentUrl'].firstChange) {
            this.navOpen = false;
        }
    }

    toggleNav(): void {
        this.navOpen = !this.navOpen;
    }

    @HostListener('document:keydown.escape')
    closeNav(): void {
        this.navOpen = false;
    }
}
